'use strict';

import {DOM} from '../helpers/DOM.js';
import {Notifications} from "../helpers/Notifications.js";
import {PhoneNumberField} from "./PhoneNumberField.js";

export default class MyAccountEdit {
	#formWrapper;
	#submitButton;
	#adminAjax;

	constructor() {
		this.#formWrapper = DOM.el('.woocommerce-EditAccountForm.edit-account');

		if (this.#formWrapper) {
			// this.#adminAjax = admin_ajax[0];
			// this.#submitButton = DOM.el('.save_account_button', this.#formWrapper)
			// this.#submitButton.disabled = true;
			//
			// if (this.#submitButton) {
			// 	this.#submitButton.disabled = false;
			// }
			//
			// this.#addEvents();
			// this.#initPasswordFields();
			// this.#initPhoneCodes();
			// this.#initAddresses();
		}
	}

	#addEvents() {
		DOM.addEvent('click', this.#submitButton, async (event, button) => {
			event.preventDefault();
			const form = button.closest('form');

			let hasError = false;

			DOM.els('[reqiuired]', form)
				.forEach(field => {
					field.classList.remove('error')
					let error = '';
					if ('checkbox' === field.type && !field.checked) {
						error = wp.i18n.__('{{label}} is required field.');
					} else if ('radio' === field.type) {
						let hasChecked = false;
						DOM.els(`input[type="radio"][name="${field.name}"]`)
							.forEach(el => {
								if (el.checked) {
									hasChecked = true;
								}
							});

						if (!hasChecked) {
							error = wp.i18n.__('{{label}} is required field.');
						}
					} else if (!field.value) {
						console.log(field, field.value);
						error = wp.i18n.__('{{label}} is required field.');
					}

					if (error) {
						this.#validationError(field, error, true);
						hasError = true;
					}
				});

			if (hasError) return;

			const {Helper} = await import('../helpers/Helper.js');

			this.#submitButton.disabled = true;

			const wrapper = form.querySelector('.levcharity_default_fields_wrapper');
			const formData = new FormData(form);

			if (wrapper) {
				const defaultFieldsContainer = new FormData();

				const defaultFieldsInputs = wrapper.querySelectorAll('input[name], select[name], textarea[name]');
				defaultFieldsInputs.forEach(input => {
					if (input.name && input.value) {
						const name = `default_fields[${input.name}]`;
						if (input.type === 'radio') {
							if (input.checked) {
								defaultFieldsContainer.append(name, input.value);
							}
						} else if (input.type === 'file') {
							defaultFieldsContainer.append(name, input.files[0]);
						} else {
							defaultFieldsContainer.append(name, input.value);
						}
						formData.delete(input.name);
					}
				});

				defaultFieldsContainer.forEach((value, name) => {
					formData.append(name, value);
				});
			}

			Helper.request(this.#adminAjax, formData, {
				headers: {}
			}, false)
				.then(response => {
					if (response?.message) {
						new Notifications()
							.setType('success')
							.setMessage(response.message)
							.execPopup();
					} else if (response?.messages?.length) {
						for (const index in response.messages) {
							const message = response.messages[index] ?? 'null'
							new Notifications()
								.setType('success')
								.setMessage(message)
								.execPopup();
						}
					} else {
						new Notifications()
							.setType('success')
							.setMessage(wp.i18n.__('Success!', 'levcharity'))
							.execPopup();
					}

					if (response?.redirect_url) {
						setTimeout(() => {
							window.location = response.redirect_url
						}, 1000);
					}
				})
				.catch(response => {
					if (response instanceof Error) {
						console.error(response.message);
						return
					}

					if (response?.message) {
						new Notifications()
							.setType('error')
							.setMessage(response.message)
							.execPopup();
					} else if (response?.messages?.length) {
						for (const index in response.messages) {
							const message = response.messages[index] ?? 'null'
							new Notifications()
								.setType('error')
								.setMessage(message)
								.execPopup();
						}
					}
				})
				.finally(() => {
					this.#submitButton.disabled = false;
				})
		})

		DOM.addEvent('input', '.edit-account input' , (event, button) =>{
			this.#submitButton.disabled = false;
		} )
		DOM.addEvent('change', '.edit-account #biirthday' , (event, button) =>{
			this.#submitButton.disabled = false;
		} )
		DOM.addEvent('change', '#billing_country', (event, button)=>{
			this.#submitButton.disabled = false;
		})
	}

	#initAddresses() {
		this.#updateAddressPreview(DOM.el('.billing_address_wrapper', this.#formWrapper), 'billing')
		this.#updateAddressPreview(DOM.el('.shipping_address_wrapper', this.#formWrapper), 'shipping')
		DOM.addEvent('click', '.address_wrapper .edit-address', (event, button) => {
			event.preventDefault();
			const wrapper = button.closest('.address_wrapper');

			const isEditing = wrapper.classList.contains('editing');

			if (isEditing) {
				wrapper.classList.remove('editing');
				button.textContent = button?.dataset?.edit || wp.i18n.__('Edit', 'levcharity');
			} else {
				wrapper.classList.add('editing');
				button.textContent = button?.dataset?.confirm || wp.i18n.__('Confirm', 'levcharity');
			}
		}, this.#formWrapper);
		DOM.addEvent('change', '.address_wrapper .edit-form', (event, form) => {
			const wrapper = form.closest('.address_wrapper')
			const type = wrapper.classList.contains('billing_address_wrapper') ? 'billing' : 'shipping';
			this.#updateAddressPreview(wrapper, type)
		}, this.#formWrapper);
	}

	#updateAddressPreview(wrapper, type) {
		if (!wrapper) return;

		const order = [
			['first_name', 'last_name'],
			['company'],
			['address_1', 'address_2'],
			['city', 'state', 'postcode', 'country'],
			['email', 'phone'],
		]

		let text = '';

		order.forEach(row => {
			let rowHtml = [];
			row.forEach(item => {
				const field = DOM.el(`[name="${type}_${item}"]`);
				const value = field?.value || '';

				if (value) {
					rowHtml.push(value)
				}
			});

			rowHtml = rowHtml.join(', ');

			if (rowHtml) {
				text += `<p class="levcharity_paragraph">${rowHtml}</p>`
			}
		})

		const previewElement = DOM.el('.preview', wrapper);

		if (previewElement) {
			previewElement.innerHTML = text || previewElement.dataset.empty || '-';
		}

	}

	#initPasswordFields() {
		DOM.addEvent('click', '.form-group .show-hide-password', (event, element) => {
			const formGroup = element.closest('.form-group');
			const input = formGroup.querySelector('input');

			if (!input) return;

			if (input.type === 'password') {
				input.type = 'text';
			} else {
				input.type = 'password';
			}

		}, this.#formWrapper);

		DOM.addEvent('input', 'input[data-type=password]', (event, password) => {
			const passwordValidationWrapper = password.closest('form')?.querySelector('.password-validation-wrapper');

			if (!passwordValidationWrapper) return;

			const letterRegex = /[a-zA-Z]/;
			const numberRegex = /\d/;
			const symbolRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?/~\\-\\"\\'\\`]/;

			if (letterRegex.test(password.value)) {
				passwordValidationWrapper.querySelector('.letter')?.classList.add('valid');
			} else {
				passwordValidationWrapper.querySelector('.letter')?.classList.remove('valid');
			}

			if (numberRegex.test(password.value)) {
				passwordValidationWrapper.querySelector('.number')?.classList.add('valid');
			} else {
				passwordValidationWrapper.querySelector('.number')?.classList.remove('valid');
			}

			if (symbolRegex.test(password.value)) {
				passwordValidationWrapper.querySelector('.symbol')?.classList.add('valid');
			} else {
				passwordValidationWrapper.querySelector('.symbol')?.classList.remove('valid');
			}

			if (password.value.length >= 7) {
				passwordValidationWrapper.querySelector('.length')?.classList.add('valid');
			} else {
				passwordValidationWrapper.querySelector('.length')?.classList.remove('valid');
			}
		}, this.#formWrapper);
	}

	#initPhoneCodes() {
		new PhoneNumberField();
	}

	async #validationError(field, message = '', showPopup = false) {
		field.classList.add('error');

		let label = DOM.el('label:not(.svg-left):not(.svg-right)', field.closest('.form-field'))?.textContent?.replace(/\*/g, '').trim();
		if (!label) {
			label = field.placeholder?.replace(/\*/g, '').trim()
		}

		if (message && showPopup) {
			message = message.replace('{{label}}', label)
			new Notifications()
				.setType('error')
				.setMessage(message)
				.execPopup();
		}
	}
}
